var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center padding-a-5 border-radius-8 background-header-gray"},[_c(_setup.VehicleOptionImage,{staticClass:"max-w-104 margin-r-3",attrs:{"vehicle-type-keys":_setup.vehicleTypeKeys}}),_c(_setup.VehicleOptionVehicleList,{attrs:{"vehicles":_vm.vehicles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }